"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-giorgio-bigarello": {
    "58b5950c": [{
      "hkey": "82f1aac3",
      "slug": "mottella-tripoli",
      "name": "Mottella-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "mottella": [{
      "hkey": "82f1aac3",
      "slug": "mottella-tripoli",
      "name": "Mottella-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "41f481af": [{
      "hkey": "82f1aac3",
      "slug": "mottella-tripoli",
      "name": "Mottella-Tripoli",
      "primary": true,
      "skipSearch": false
    }],
    "tripoli": [{
      "hkey": "82f1aac3",
      "slug": "mottella-tripoli",
      "name": "Mottella-Tripoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-giorgio-bigarello"
    }]
  }
};
exports["default"] = _default;